<template>
    <v-dialog v-model="value.showDialog" hide-overlay persistent max-width="800px">
        <bot-spinner v-model="spinner">
            <v-card class="project-item" :loading="spinner.visible">
                <v-card-title>
                    <span>Cập nhật dự án</span>
                    <v-spacer></v-spacer>
                    <v-btn color="success darken-1" text @click="submit" :disabled="!isValid">
                        <v-icon left> mdi-check </v-icon>
                        Xác nhận
                    </v-btn>
                    <v-btn color="pink" text @click="handleCloseDialog">
                        <v-icon left> mdi-close </v-icon>
                        Hủy
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-form v-model="isValid" ref="form" @keyup.native.enter="submit" @submit.prevent="submit">
                        <v-list-item>
                            <v-text-field v-model="value.ProjectTitle" autofocus label="Tên dự án" :rules="[
                                (val) =>
                                    vld.text({
                                        field: 'tên dự án',
                                        value: val,
                                    }),
                            ]"></v-text-field>
                        </v-list-item>
                        <v-list-item>
                            <v-text-field v-model="value.DomainName" label="Tên miền chính" :rules="[
                                (val) =>
                                    vld.href({
                                        field: 'tên miền',
                                        value: val,
                                    }),
                            ]"></v-text-field>
                        </v-list-item>
                    </v-form>
                </v-card-text>
            </v-card>
        </bot-spinner>
    </v-dialog>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            projects: {
                add: "views/projects/add",
            },
        },
    },
    sms: {
        success: {
            add: "Thêm dự án mới thành công!",
        },
    },
};
const df = cafe.default;

export default {
    name: "project-item",

    props: ["value"],

    components: {
        "bot-spinner": BotSpinner,
    },

    // this is state
    data() {
        return {
            vld: this.$options.filters.validate,
            hlog: this.$options.filters.hlog,
            tgh: this.$options.filters.tgh,
            tufl: this.$options.filters.tufl,
            isValid: false,
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
    },

    methods: {
        async submit() {
            var main = this;
            const { form } = main.$refs;
            if (!form) return;
            main.isValid = form.validate();
            if (!main.isValid) return;

            main.spinner.visible = true;
            const dp = main.$store.dispatch;
            let ProjectTitle = main.tufl(main.value.ProjectTitle);
            let ProjectHost = main.tgh(main.value.DomainName);
            let payload = { ProjectTitle, ProjectHost };
            let success = cafe.sms.success.add;
            let res_update = await dp(df.sp.projects.add, payload);
            console.log("res_update", res_update);
            let text = res_update.error;
            if (text) return dp(df.sp.snb, { text, color: "error" });
            text = success;
            dp(df.sp.snb, { text, color: "success" });
            main.spinner.visible = false;
            main.value.showDialog = false;
        },
        handleCloseDialog() {
            this.value.showDialog = false;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// project.item.vue